const topCategoryIds: Array<string> = [
  '644b497b-d941-5645-907c-77c1474096b5',
  'de1870f3-e938-5dfa-9f6d-4594a80cdd44',
  'ff57f6a0-fa41-5240-bd1e-7ff6cc3899d3',
  'b5bbef9d-7014-5269-9a71-b9fd75758328',
  'edfc04f2-a954-5034-a762-1d8800eb7536',
]

function getMerchandiseTopCategories(): Promise<Array<string>> {
  // Currently not implemented in the back end, so we're returning a hard coded curated list back
  return Promise.resolve(topCategoryIds)
}

export default getMerchandiseTopCategories
